<template>

    <v-card flat class="conteneurLead">

      <v-card-title class="primary white--text"  style="height: 52px;  padding: 0px;">
        <v-btn icon @click="cancelDialog()"><v-icon class="white--text">close</v-icon></v-btn>
        <span class="title">{{ $t('statSuperv8')}}</span>
        <v-spacer></v-spacer>
      </v-card-title>

      <v-card-text>
        <v-flex xs12>
          <v-card class="mb-3" height="400px" v-if="loading">
            <v-card-text class="text-xs-center pt-5">
              <v-progress-circular indeterminate class="primary--text"></v-progress-circular>
            </v-card-text>
          </v-card>
        </v-flex>
        <v-flex xs12>
          <v-card v-if="!loading" class="mb-3" >
            <v-flex d-flex xs12>
              <v-layout row wrap>
                <v-flex d-flex md12>
                  <v-flex xs12 >
                    <highcharts :options="agentConnexions"></highcharts>
                  </v-flex>
                </v-flex>
                <v-flex d-flex md12>
                  <p class="totalTime">{{ $t('statSuperv21')}} : <strong>{{totalConnexionAgents}}</strong></p>
                  </v-flex>
              </v-layout>
            </v-flex>

          </v-card>
        </v-flex>
      </v-card-text>

      <!-- DIALOGUES OCCUPATION AGENT DAY-->
      <v-dialog
      v-model="occupationAgentDay"
      persistent
      max-width="1200px"
      :scrollable="!$vuetify.breakpoint.smAndDown"
      :fullscreen="$vuetify.breakpoint.smAndDown"
    >
      <wz-agents-occupation-day
          v-if="occupationAgentDay"
        :dataAgentSelected="dataAgentSelected"
        @closeDialog="dialogOccupationRemove"
      ></wz-agents-occupation-day>
    </v-dialog>

      <!-- DIALOGUES OCCUPATION AGENT DAY-->
    <!-- <div
      v-if="occupationAgentDay"
    >
      <wz-agents-occupation-day
          v-if="occupationAgentDay"
        :dataAgentSelected="dataAgentSelected"
        @closeDialog="dialogOccupationRemove"
      ></wz-agents-occupation-day>
    </div> -->
    </v-card>
 
  
</template>

<script>
import _ from 'lodash'
import moment from 'moment'
// import momentTz from 'moment-timezone'
import 'moment-duration-format'
import { mapGetters, mapState } from 'vuex'
import json2csv from 'json2csv'

export default {
  props: {
    dataAgentsSelected: {
      type: Object,
      default: {}
    }
  },
  data () {
    return {
      // chats par agent
      loading: false,
      occupationAgentDay: false,
      utcDecal: '',
      tempsPresence: 28800,
      totalJoursOuvres: 1, // nombre de jours travaille sur la période
      totalTempsConnexion: 0,
      totalTempsPresence: 0,
      totalTempsAllChats: 0, // temps total de chat
      tempsTotalOnline: 0, // temps total online en econdes
      tempsTotalBusy: 0, // temps total busy en secondes
      tempsOccupationBusy: 0, // pour confirmer si les chiffres collent
      moyenChatMax: 0, // moyen des chats max sur la durrée (au cas ou elle change en cours de durrée)
      tempsOccupationPartielle: 0, // occupation partielle, agent online en chat mais pas fullChat
      totalTempsChat: [0, 0, 0, 0],
      tauxProductivity1: 0,
      tauxProductivity2: 0,
      tauxProductivity3: 0,
      agentsName: [],
      agents: [],
      totalTimeConnexion: 0,
      dataAgentSelected: {agentID: ''},
      // options générales pour les graphiques
      optionsGraph: {
        chart: {
        },
        colors: [
          '#F44336', // red
          '#3F51B5', // indigo
          '#009688', // teal
          '#E91E63', // pink
          '#607D8B', // blue-grey
          '#9C27B0', // purple
          '#2196F3', // blue
          '#FF5722', // deep-orange
          '#795548', // brown
          '#4CAF50', // green
          '#8BC34A', // light-green
          '#673AB7', // deep-purple
          '#CDDC39', // lime
          '#03A9F4', // light-blue
          '#FFC107', // amber
          '#FF9800', // orange
          '#FFEB3B', // yellow
          '#00BCD4', // cyan
          '#9E9E9E'  // grey
        ],
        title: {
          style: {
            fontSize: '20px',
            fontFamily: '"Inconsolata", sans-serif'
          }
        },
        plotOptions: {
        },
        credits: {
          enabled: false
        },
        exporting: {
          enabled: false
        }
      },

      // options pour le graphique des chats par agent
      agentConnexions: {
        chart: {
          type: 'xrange'
        },
        colors: [
          this.dataAgentsSelected.agentColor
        ],
        title: {
          text: this.$t('statSuperv22') + moment.parseZone((this.dataAgentsSelected.dateStart * 1000)).format('LL')
          // text: 'connexions  : ' + moment.duration((this.totalTempsConnexion / 60), 'minutes').format('h [h] m [min]')
        },
        legend: {
          enabled: true
        },
        xAxis: {
          type: 'datetime',
          maxPadding: 0.1,
          minorGridLineColor: '#f1f1f1',
          minorTickInterval: 'auto',
          min: ((this.dataAgentsSelected.dateStart * 1000) + 21600000), // date de depart (00:00) + 6 h
          max: ((this.dataAgentsSelected.dateEnd * 1000) - 7200000) // date de fin (23:59) - 3 h
        },
        yAxis: {
          title: {
            text: this.$t('conseiller') + '(s)'
          },
          categories: [],
          reversed: false
        },
        plotOptions: {
          column: {
            stacking: 'normal',
            dataLabels: {
              enabled: false
            }
          },
          series: {
            cursor: 'pointer',
            allowPointSelect: true,
            point: {
              events: {
                click: (e) => {
                  this.openDayOccupation(e)
                  console.log('openDayOccupation', e)
                  // console.log('id agent', this.series.userOptions.agentID)
                }
              }
            }
          }
        },
        tooltip: {
          crosshairs: true,
          // pointFormat: '{series.name}: <b>{point.visiteurId}</b><br/>',
          valueSuffix: ' cm',
          shared: true,
          useHTML: true,
          headerFormat: '<small style="color: {series.color}">' + this.$t('connections') + '</small><table>',
          pointFormat: '<tr><td>De : </td><td><b>{point.debut}</b></td></tr>' +
              '<tr><td>à : </td><td><b>{point.fin}</b></td></tr>',
          footerFormat: '</table>'
        },
        series: []
      }
    }
  },

  created () {
    console.log('created vue')
    console.log('Date.UTC(2010, 0, 1, 0, 0, 0)', Date.UTC(2010, 0, 1, 0, 0, 0))
    console.log('this.dataAgentsSelected.dateStart', this.dataAgentsSelected.dateStart)
    console.log('this.dataAgentsSelected.dateEnd', this.dataAgentsSelected.dateEnd)
    this.tempsPresence = ((this.dataAgentsSelected.tempsTravail * 60) * 60) // heures en secondes
    console.log('tempsPresence', this.dataAgentsSelected)
    // affichage des loaders
    // this.loadingAgentsChats = true
    // this.loadingAgentsActivity = true
    // initialisation des options liées aux graphiques
    // this.agentOccupation = _.merge(this.agentOccupation, this.optionsGraph)
    this.agentConnexions = _.merge(this.agentConnexions, this.optionsGraph)
    // this.agentStatus = _.merge(this.agentStatus, this.optionsGraph)
    // this.productivityAgent = _.merge(this.productivityAgent, this.optionsGraph)
    // this.activityAgent = _.merge(this.activityAgent, this.optionsGraph)
    // this.getAll()
    // const _self = this
    // recupère les données de tous les agents
    this.axios.get('get/agents.php')
    .then(response => {
      this.resAjx = response.data
      this.init()
    })
    .catch()
    .then(_ => {
      // this.loading = false
    })
  },

  mounted () {
    this.loading = true
    let dateNow = Date.now()
    let inverseOffset = moment(dateNow).utcOffset()
    console.log('inverseOffset', inverseOffset)
    this.utcDecal = inverseOffset
    // console.log('mounted vue')
    console.log('dataAgentsSelected', this.dataAgentsSelected)
    // this.getOccupation()
    this.getConnexions()
  },

  computed: {
    ...mapGetters('_Stats', ['params']),
    ...mapState('_User', ['brides']),
    // affiche le temps total en activité partiel
    // afficheAgentsName () {
    //   let agentsName = []
    //   if (this.dataAgentsSelected.agents.length) {
    //     for (let index = 0; index < this.dataAgentsSelected.agents.length; index++) {
    //       agentsName.push(this.dataAgentsSelected.agents[index].name)
    //     }
    //   }
    //   console.log('agentsName', this.agentsName)
    //   return agentsName
    // }
    // affiche le temps hors production
    totalConnexionAgents () {
      return moment.duration(this.totalTimeConnexion).format('h [h] m [min] s [sec]')
    }
  },

  methods: {
    // recupere la liste de tous les agents dispo avec leur temps de travail
    init () {
      // console.log('init', this.resAjx)
      for (var id in this.resAjx) {
        this.agents.push({ id: this.resAjx[id][0].USR_ID,
          name: _.trim(this.resAjx[id][0].USR_FIRST_NAME + ' ' + this.resAjx[id][0].USR_LAST_NAME),
          rights: _.toInteger(this.resAjx[id][0].USR_RIGHTS),
          tempsTravail: this.resAjx[id][0].USR_TIME_DAY,
          joursHebdo: this.resAjx[id][0].USR_DAY_HEBDO,
          isbot: this.resAjx[id][0].USR_IS_BOT !== '',
          botid: this.resAjx[id][0].USR_IS_BOT
        })
      }
      // console.log('this.agents', this.agents)
    },
    /**
     * lance toutes les requêtes
     */
    getConnexions () {
      console.log('get connexion')
      this.totalTimeConnexion = 0 // remise à zéro du temps
      let agentsId = []
      let tempsTravail = []
      if (this.dataAgentsSelected.agents.length) {
        for (let index = 0; index < this.dataAgentsSelected.agents.length; index++) {
          agentsId.push(this.dataAgentsSelected.agents[index].id)
          tempsTravail.push(this.dataAgentsSelected.agents[index].tempsTravail)
          this.agentsName.push(this.dataAgentsSelected.agents[index].name)
        }
      }
      // console.log('this.dataAgentsSelected.agents', this.dataAgentsSelected.agents)
      this.agentConnexions.series.push({'data': []})
      let param = 'dateStart=' + encodeURIComponent(this.dataAgentsSelected.dateStart) +
        '&refTime=' + encodeURIComponent(tempsTravail) +
        '&dateEnd=' + encodeURIComponent(this.dataAgentsSelected.dateEnd) +
        '&agentId=' + encodeURIComponent(agentsId)
      console.log('param', param)
      this.axios.get('get/connexionAgentsDay.php?' + param)
      .then(response => {
        console.log('response : ', response)
        console.log('response : ', response.data.day)

        // Attention toutes les date ajax sont en UTC 0
        // Maj des colonnes stockées (data par jour)
        if (response.data) {
          for (let index = 0; index < response.data.connexions.length; index++) {
            let values = response.data.connexions[index]
            let previousValues = response.data.connexions[(index - 1)]

            // verificartion si pas multisession
            if (values.type !== 8) {
              if (this.dataAgentsSelected.agents.length) {
                for (let i = 0; i < this.dataAgentsSelected.agents.length; i++) {
                  if (Number(this.dataAgentsSelected.agents[i].id) === values.agentId) {
                    values.agentName = this.dataAgentsSelected.agents[i].name
                  }
                }
              }
              // c'est la ligne qui suit une multisession on ne l'ajoute pas au tableau
              if (previousValues && previousValues.type !== 8) {
                // total temps de connexion uniquement si la valeur est validé ou active
                // cas d'une deconnexion forcé
                if (values.x2 > values.x) {
                  this.totalTempsConnexion = this.totalTempsConnexion + (values.x2 - values.x)
                  // ajout des jours dans l'axe des X
                  values.y = (values.y - 1)
                  // convertion des dates sur le bon timeZone
                  let dateS = (values.x * 1000) + (this.utcDecal * 60000)
                  let dateE = (values.x2 * 1000) + (this.utcDecal * 60000)
                  // console.log('dateS', dateS)
                  // dates pour le tooltips
                  values.debut = moment.utc(dateS).format('LTS')
                  values.fin = moment.utc(dateE).format('LTS')
                  // console.log('values.debut', values.debut)
                  // dates pour le graphique
                  values.x = dateS
                  values.x2 = dateE
                  // cumule des temps de connexion
                  this.totalTimeConnexion = this.totalTimeConnexion + (values.x2 - values.x)
                  // ajoute les données finales
                  this.agentConnexions.series[0].data.push(values)
                }
              }
              // si c'est le premier et c'est pas du type 8 on ajoute
              if (index === 0) {
                // uniquement si la valeur x2 plus grande que x
                if (values.x2 > values.x) {
                  // total temps de connexion
                  this.totalTempsConnexion = this.totalTempsConnexion + (values.x2 - values.x)
                  // ajout des jours dans l'axe des X
                  values.y = (values.y - 1)
                  // convertion des dates sur le bon timeZone
                  let dateS = (values.x * 1000) + (this.utcDecal * 60000)
                  let dateE = (values.x2 * 1000) + (this.utcDecal * 60000)
                  // console.log('dateS', dateS)
                  // dates pour le tooltips
                  values.debut = moment.utc(dateS).format('LTS')
                  values.fin = moment.utc(dateE).format('LTS')
                  // values.agentId = values.agentId
                  // console.log('values.debut', values.debut)
                  // dates pour le graphique
                  values.x = dateS
                  values.x2 = dateE
                  // cumule des temps de connexion
                  this.totalTimeConnexion = this.totalTimeConnexion + (values.x2 - values.x)
                  // ajoute les données finales
                  this.agentConnexions.series[0].data.push(values)
                }
              }
            }
            // this.agentOccupation.series[0].data.push(values)
          }
          this.agentConnexions.series[0].name = this.$t('connections')
          this.agentConnexions.series[0].day = response.data.day
          this.agentConnexions.series[0].dataLabels = {enabled: false}
          this.agentConnexions.series[0].color = this.optionsGraph.colors[4]
          this.agentConnexions.yAxis.categories = this.agentsName
          // console.log(this.agentsName)
          // this.agentConnexions.series[0].color = this.optionsGraph.colors[4]
          // this.agentConnexions.series[0].total = this.totalTempsConnexion
          // this.agentConnexions.series[0].data = response.data.connexions
          console.log('this.agentConnexions : ', this.agentConnexions.series[0].data)
          console.log('totalTimeConnexion', this.totalTimeConnexion)
        }
      })
      .catch()
      .then(_ => {
        this.loading = false
        // this.occupationAgentDay = true
        // charge les status agent
        // this.getStatusAgent()
      })
    },

    /**
     * Ouvre l'occupation d'un agent à la journée selectionné
     */
    openDayOccupation (data) {
      console.log('data user : ', data)
      let indexDate = data.point.index
      let agentID = data.point.series.userOptions.data[indexDate].agentId
      let tempsTravailJour = 0
      let joursSemaine = 0
      for (let a = 0; a < this.agents.length; a++) {
        // console.log('toto', arrayAgentIdSelected[b])
        if (Number(this.agents[a].id) === agentID) {
          // console.log('this.agents[a]', this.agents[a])
          tempsTravailJour = this.agents[a].tempsTravail
          joursSemaine = this.agents[a].joursHebdo
        }
      }
      // console.log('date (category) : ', data.point.category)
      // console.log('agent id : ', data.point.series.userOptions.agentID)
      // console.log('agent name : ', data.point.series.userOptions.name)
      // let indexDate = data.point.index
      // console.log('date : ', data.point.series.userOptions.day[indexDate])
      // console.log('date seleted ', data.point.series.userOptions.arrayDays[indexDate].date)
      let dateStart = Number(moment.parseZone(data.point.series.userOptions.day).format('X'))
      // console.log('dateStart', dateStart)
      let dateEnd = dateStart + 86400
      // let agentID = data.point.series.userOptions.agentID
      this.dataAgentSelected.dateStart = dateStart
      this.dataAgentSelected.dateEnd = dateEnd
      this.dataAgentSelected.agentID = agentID
      this.dataAgentSelected.agentName = data.point.series.userOptions.data[indexDate].agentName
      this.dataAgentSelected.agentColor = data.point.color
      this.dataAgentSelected.tempsTravail = tempsTravailJour
      this.dataAgentSelected.joursHebdo = joursSemaine
      // console.log('dateStart : ', dateStart)
      this.occupationAgentDay = true
    },

    dialogOccupationRemove () {
      this.occupationAgentDay = false
    },

    // ---------------------------------------------
    // pour tester si autorisé à afficher
    // ---------------------------------------------
    brideMenu (nameBride) {
      if (this.brides) {
        let index = this.brides.findIndex(bride => bride.brideName === nameBride)
        // console.log('index', index)
        if (index !== -1) {
          return this.brides[index].status
        }
      }
    },

    /**
     * lance toutes les requêtes
     */
    getAll () {
      this.getConnexions()
    },

    /**
     * Close dialogue occupation
     */
    cancelDialog () {
      // this.dialogEdit = false
      this.$emit('closeDialog')
    },

    /**
     * exporte en csv
     */
    exportAgentsChatsPie () {
      let csv = ''
      let data = []
      let fields = []
      let fieldNames = ['agent', 'chats', 'percentage']
      fields = ['name', 'chats', 'y']
      data = this.agentsChatsPieComputed
      try {
        csv = json2csv({ data, fields, del: ';', fieldNames })
      } catch (err) {
        return
      }
      this.downloadFile('agentsChatsPie.csv', csv)
    },

    downloadFile (filename, content) {
      let hiddenElement = document.createElement('a')
      hiddenElement.href = 'data:attachment/text,' + encodeURI(content)
      hiddenElement.target = '_blank'
      hiddenElement.download = filename
      document.body.appendChild(hiddenElement)
      hiddenElement.click()
    }
  },

  watch: {
    params (v) {
      this.getAll()
    }
  }
}
</script>

<style scoped>
 .totalTime{text-align: center;}
</style>



// WEBPACK FOOTER //
// src/components/watcheezy/WzAgentsPresenceDay.vue